import axios from "axios";
import { headerConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL } from "../utility/URL";



const taxInvoiceSave = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "sale/action", data, headerConfig);
        return response;
};

const taxInvoiceList = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "sale/list", data, headerConfig);
        return response;
};

const taxInvoiceGetByID = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "sale/sale-details", data, headerConfig);
        return response;
};


const taxInvoiceService = {
    taxInvoiceSave,
    taxInvoiceList,
    taxInvoiceGetByID
};

export default taxInvoiceService;